





















































import Vue from 'vue'
import { Table13ElInterface, TableRow } from '@/config/interfaces'

export default Vue.extend({
  name: 'Table13El',

  data: () => ({
    colors: [] as Array<string>
  }),

  mounted () {
    this.setColors()
  },

  computed: {
    resolveStyles (): string {
      return `display: grid;grid-template-columns: 2fr repeat(${this.rowLength - 1}, 1fr);`
    },
    rowLength (): number {
      return Object.keys(this.$props.templateItemData.rows[0]).filter(obj => obj.match('col')).length
    }
  },

  methods: {
    setColors (): void {
      const colors: Array<string> = []
      this.templateItemData.header.forEach(item => {
        const col = item.color === '' ? (this.$vuetify.theme.dark ? '#00182C' : '#FFFFFF') : item.color
        colors.push(col)
      })
      this.colors = colors
    },
    visible (row: TableRow): Array<string> {
      const filtered = Object.entries(row).filter(([key]) => (key.match('col') && !key.match('col1')))
      return Object.values(Object.fromEntries(filtered))
    }
  },

  props: {
    templateItemData: {
      type: Object as () => Table13ElInterface,
      required: true
    }
  }
})
